<template>
  <div class="nav-logo">
    <router-link :to="link">
      <img class="display-pc" :src="logoImg.pc">
      <img class="display-mobile" :src="logoImg.mobile">
    </router-link>
    <div class="logo-detail">
      <h2 v-if="title1">{{title1}}</h2>
      <h2 v-if="title2">{{title2}}</h2>
      <h2 v-if="title3">{{title3}}</h2>
      <h2 v-if="title4">{{title4}}</h2>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /**
     * logo 链接
     */
    logoImg: {
      type: Object,
      default: () => {
        return {
          pc: '',
          mobile: ''
        }
      }
    },
    title1: String,
    title2: String,
    title3: String,
    title4: String,
    link: String
  }
}
</script>

<style lang="sass" scoped>
$colorText: #464646

.nav-logo
  display: flex
  align-items: center
  line-height: 1
  a
    height: 60px
    // width: 148px
    position: relative
    top: -2px
    // background-image: url('../../assets/logo-qcon.jpg')
    background-position: center
    background-repeat: no-repeat
    background-size: contain
    img
      height: 100%
    +mobile
      // background-image: url('../../assets/logo-qcon.svg')
      height: 35px
      width: 120px
      top: 0
  .logo-detail
    border-left: 1px solid #888
    padding-left: 9px
    margin-left: 9px
    transition: all $speed ease-in-out
    h1
      margin-bottom: 6px
      font-size: 15px
      color: $colorText
    h2
      &:nth-child(n+2)
        margin-top: 3px
      font-size: 13px
      color: $colorText
    h3
      font-size: 12px
      color: $colorText
  +mobile
    .logo-detail
      display: none
  +tablet
    &.transparent
      a
        // background-image: url('../../assets/img/logo-qcon.svg')
      h1, h2, h3
        color: $white
        font-weight: 500
</style>
